import { render, staticRenderFns } from "./TrophyIconParts.vue?vue&type=template&id=64d527ab&scoped=true"
import script from "./TrophyIconParts.vue?vue&type=script&lang=ts"
export * from "./TrophyIconParts.vue?vue&type=script&lang=ts"
import style0 from "./TrophyIconParts.vue?vue&type=style&index=0&id=64d527ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d527ab",
  null
  
)

export default component.exports